import { ReactNode, FunctionComponent, SVGProps } from 'react'

import { ReactComponent as CollapseIcon } from './collapse.svg'
import { ReactComponent as ExpandIcon } from './expand.svg'

interface Props {
  collapseIconComponent?: FunctionComponent<React.PropsWithChildren<SVGProps<SVGSVGElement>>>
  collapsed: boolean
  children?: ReactNode
  expandIconComponent?: FunctionComponent<React.PropsWithChildren<SVGProps<SVGSVGElement>>>
  onToggle: (collapsed: boolean) => void
  className?: string
  'aria-label'?: string
}

export const Collapse = ({
  collapsed,
  onToggle,
  children,
  expandIconComponent: ExpandIconComponent = ExpandIcon,
  collapseIconComponent: CollapseIconComponent = CollapseIcon,
  className,
  ...rest
}: Props) => {
  const handleToggleClick = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    onToggle(!collapsed)
  }
  return (
    <button onClick={handleToggleClick} type="button" className={className} aria-label={rest['aria-label']}>
      {children} {collapsed ? <ExpandIconComponent /> : <CollapseIconComponent />}
    </button>
  )
}
